import { render, staticRenderFns } from "./Olt.vue?vue&type=template&id=6c7e03a7&"
import script from "./Olt.vue?vue&type=script&lang=js&"
export * from "./Olt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports